import React from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaGithub, FaNewspaper } from 'react-icons/fa';
import { projects } from '../content/data';

const Featured = ({ onProjectClick }) => {
  const featuredProjects = projects.filter((p) => p.featured).slice(0, 3);

  return (
    <section id="featured" className="section-padding bg-page-light">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-h1 gradient-text mb-3">Featured Work</h2>
          <p className="text-muted text-body-lg">My most impactful projects</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {featuredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="card group cursor-pointer"
              onClick={() => onProjectClick(project)}
            >
              <div className="aspect-video overflow-hidden rounded-t-card">
                <img
                  src={`/projects/${project.image}`}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="text-h3 text-white mb-2 group-hover:text-accent-blue transition-colors">
                  {project.title}
                </h3>
                <p className="text-muted text-caption mb-4 line-clamp-2">
                  {project.tagline}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.stack.slice(0, 4).map((tech) => (
                    <span key={tech} className="chip text-xs">
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="flex gap-2">
                  {project.links.demo && (
                    <a
                      href={project.links.demo}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-primary text-xs py-2 px-3 flex items-center gap-1"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <FaExternalLinkAlt className="text-[10px]" />
                      Demo
                    </a>
                  )}
                  {project.links.code && (
                    <a
                      href={project.links.code}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-secondary text-xs py-2 px-3 flex items-center gap-1"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <FaGithub />
                      Code
                    </a>
                  )}
                  {project.links.caseStudy && (
                    <a
                      href={project.links.caseStudy}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-secondary text-xs py-2 px-3 flex items-center gap-1"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <FaNewspaper />
                      Case Study
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featured;
